import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from "store/index";

export interface ModalInfo {
  id?: string,
  show?: boolean,
  onHide?: any,
  render: any,
  title?: string,
  backdrop?: true | false | 'static',
  keyboard?: boolean,
  hideCloseButton?: boolean,
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl',
  headless?: boolean
}

export interface ModalState {
  modals: ModalInfo[];
}

const initialState: ModalState = {
  modals: []
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (state: ModalState, action: PayloadAction<ModalInfo>) => {
      state.modals.push({
        id: crypto.randomUUID(),
        show: true,
        render: action.payload.render,
        onHide: action.payload.onHide,
        title: action.payload.title,
        hideCloseButton: action.payload.hideCloseButton ?? false,
        backdrop: action.payload.backdrop ?? 'static',
        keyboard: action.payload.keyboard ?? false,
        size: action.payload.size ?? 'lg',
        headless: action.payload.headless ?? false
      });
    },
    hideModal: (state: ModalState) => {
      state.modals.pop();
    },
    resetModal: (state: ModalState) => {
      state.modals = [];
    }
  }
});

export const {
  showModal,
  hideModal,
  resetModal
} = modalSlice.actions;

export const modalReducer = (state: RootState) => state.modalOverScreen;

export const ModalReducer = modalSlice.reducer;
